module.exports = __webpack_public_path__ + "img/yzappfw3.5d0a5f38.png";